<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-10">
            <div class="card-box">
                <div class="Chart">
                    <canvas id="orderHolderFilter" width="60" height="50"></canvas>
                </div>
            </div>
            <div v-if="totalCertifieds && totalCertifieds > 0 && totalParts && totalParts > 0 && totalServices && totalServices > 0" style="font-size:15px; text-align:center;" class="form-row">
                <div class="form-group col-md-4">
                    <label>Total de Certificados:</label> {{totalCertifieds}}
                </div>
                <div class="form-group col-md-4">    
                    <label>Total de Peças:</label> {{totalParts}}
                </div>
                <div class="form-group col-md-4">
                    <label>Total de Serviços:</label> {{totalServices}}
                </div>
            </div>
        </div>
    </div>
</template>
            
<script>
import Chart from 'chart.js';
import Controller from './CrtOrderHolderFilter';
export default {
  
    name: 'OrderHolderFilter',
    components: {
    },
    
    data() {
    return {
        chart: null,
        totalCertifieds: 0,
        totalParts:0,
        totalServices:0,

      }
    },
    methods: Controller.methods,
    created() {
      Controller.init(this);
    },
    mounted() {

        const ctx = document.getElementById('orderHolderFilter');
        this.chart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: null,
            datasets: [{ 
                    label: 'Certificados',
                    data: null,
                    backgroundColor: "#C13018",
                    borderColor: "#C13018",
                    fill: false,
                },
                { 
                    label: 'Peças',
                    data: null,
                    backgroundColor: "#063951",
                    borderColor: "#063951",
                    fill: false,
                },
                { 
                    label: 'Serviços',
                    data: null,
                    backgroundColor: "#32CD32",
                    borderColor: "#32CD32",
                    fill: false,
                }],
        },
        options: { 
			tooltips: {
				mode: 'index',
				intersect: false,
			},
			hover: {
				mode: 'nearest',
				intersect: true
			},
			scales: {
				xAxes: [{
					display: true,
					scaleLabel: {
						display: true,
						labelString: 'Ano-Mês'
					}
				}],
				yAxes: [{
					display: true,
					scaleLabel: {
						display: true,
						labelString: 'Pedidos'
					}
				}]
			},
            title: {
                display: true, 
            },
            legend: {
                fullWidth: true,
                labels: {
                    fontColor: '#000',
                    boxWidth: 20, 
                }
            },
        }
      });
      this.filter();
    }
}
    

</script>